import { FeedCurveMilestone } from "../../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall";

export const getCurrentMilestone = (
  xValue: number,
  milestones: FeedCurveMilestone[]
): {
  milestone: FeedCurveMilestone | undefined;
  relativeX: number;
  sorted: FeedCurveMilestone[];
} => {
  if (!milestones || milestones.length === 0)
    return { milestone: undefined, relativeX: 0, sorted: [] };

  const sorted = [...milestones].sort((a, b) => a.milestoneIndex - b.milestoneIndex);

  let cumulativeDay = 0;

  for (let i = 0; i < sorted.length; i++) {
    const milestone = sorted[i];

    // Brug fallback hvis feedDays mangler
    const feedDays = milestone.feedDays ?? [];
    const daysInMilestone = feedDays.length > 0 
      ? Math.max(...feedDays.map(d => d.day)) 
      : 0;

    const startDay = cumulativeDay;
    const endDay = cumulativeDay + daysInMilestone;

    if (xValue >= startDay && xValue <= endDay) {
      const relativeX = xValue - startDay;
      return { milestone, relativeX, sorted };
    }

    cumulativeDay = endDay + 1;
  }

  const lastMilestone = sorted[sorted.length - 1];
  const lastFeedDays = lastMilestone.feedDays ?? [];
  return {
    milestone: lastMilestone,
    relativeX: lastFeedDays.length > 0 ? Math.max(...lastFeedDays.map(d => d.day)) : 0,
    sorted,
  };
};
